<template>
  <ib-dialog
    :visible="dialogVisible"
    width="530px"
    top="8vh"
    @close="closeDialog"
    @closed="onClose"
    @open="generateDocument"
  >
    <div class="dialog-body">
      <div class="text-center">
        <img src="@/assets/img/illustrations/export-financials.svg" alt="">
      </div>
    </div>
    <div class="d-flex flex-column align-items-center">
      <template v-if="loading">
        <div class="font-outfit-medium dialog-export-title">
          {{ $t('dialogs.export.exportingInProgress') }}
        </div>
        <p class="text-lead o-50">
          {{ $t('pleaseWait') }}...
        </p>
      </template>

      <h5 v-if="error" class="text-danger">
        {{ $t('somethingWentWrongTryAgainLater') }}
      </h5>

      <template v-if="generateDialogUrl">
        <div class="font-outfit-medium dialog-export-title">
          {{ $t('dialogs.export.exportCompleted') }}
        </div>
      </template>
    </div>

    <template #footer>
      <ib-divider v-if="!loading" block class="mb-4" />
      <template v-if="generateDialogUrl">
        <a :href="generateDialogUrl" target="_blank">
          <ib-button size="md">
            {{ $t('openFile') }}
          </ib-button>
        </a>
      </template>
    </template>
  </ib-dialog>
</template>

<script>
export default {
  name: 'DialogGenerate',

  props: {
    dialogVisible: {
      type: Boolean,
      default: false
    },
    sharedIdea: {
      type: Object,
      default: null
    },
    api: {
      type: String,
      default: '/story-mode/overview/generate'
    },
    format: {
      type: String,
      default: 'pdf'
    },
    active: {
      type: Object,
      default: () => ({})
    }
  },

  data () {
    return {
      loading: false,
      error: false,
      generateDialogUrl: '',
      generateDocumentName: 'overview'
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    onClose () {
      this.generateDialogUrl = ''
      this.error = false
    },

    getIdea () {
      return this.sharedIdea || this.$store.state.idea
    },

    async generateDocument () {
      this.generateDialogUrl = ''
      this.generateDialog = true
      this.loading = true

      this.$gtm.trackEvent({
        event: this.format + 'Export'
      })

      try {
        const response = await this.$http.post(
          this.api,
          {
            ideaId: this.getIdea().id,
            format: this.format,
            active: this.active
          }
        )

        if (response.status === 200) {
          this.generateDialogUrl = response.data.payload.url
          this.loading = false
        }
      } catch (e) {
        this.error = true
        this.loading = false
      }
    }
  }
}
</script>

<style scoped lang="scss">
.dialog-export-title {
  font-size: 30px;
  color: $color-font;
  margin: 35px 0 25px;
}
</style>
